// removed by extract-text-webpack-plugin
module.exports = {"Item":"src-components-Misc-Github-Item----Item-module---Item---3e9_8","Data":"src-components-Misc-Github-Item----Item-module---Data---3oGg-","Type":"src-components-Misc-Github-Item----Item-module---Type---3D1bF","Name":"src-components-Misc-Github-Item----Item-module---Name---C-mpJ","Time":"src-components-Misc-Github-Item----Item-module---Time---3nvO6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Misc/Github/Item/Item.module.css
// module id = 354
// module chunks = 35783957827783